import React from 'react'
import { Toolbar } from '@planningcenter/topbar'
import { string } from 'prop-types'

const APIToolbar = ({ appName, railsEnv, userAvatarPath, userName }) => {
  const handleHelpdeskClick = (e) => {
    e.preventDefault()
    window.open(
      'https://github.com/planningcenter/developers/issues',
      '_blank',
      'noopener, noreferrer'
    )
  }
  return (
    <Toolbar
      appName={appName}
      env={railsEnv}
      userAvatarPath={userAvatarPath}
      userName={userName}
      linkToProfile={false}
      helpdeskConfig={{ onClick: handleHelpdeskClick }}
    />
  )
}

APIToolbar.propTypes = {
  railsEnv: string.isRequired,
  appName: string.isRequired,
  userAvatarPath: string.isRequired,
  userName: string.isRequired,
}

export default APIToolbar
